<template>
  <div class="student-activities-banner">
    <div class="wrapper">
      <div class="header">
        <div class="top">Узнай сколько студентов подходит вашей компании</div>
        <div class="footer">
          Вы ищете тех, кто будет заинтересован в вашем предприятии, или тех, кто уже разрабатывает
          научные проекты в сельском хозяйстве и ищет возможность их реализовать? Оставляйте заявку
          и мы найдем вам подходящих студентов.
        </div>
      </div>
      <BaseButtonLink
        class="button-link"
        name="Узнать подробнее"
        link="/for-employers/student-activities"
        theme="banana"
      />
    </div>
  </div>
</template>

<script lang="ts" setup>
  import { BaseButtonLink } from '~/components/base-ui/buttons'

  const img = useImage()
  const bannerImageUrl = `url(${img('/banners/student-activities/banner-image.png', { format: 'webp' })})`
</script>

<style scoped lang="scss">
  .student-activities-banner {
    max-width: 1280px;
    width: 100%;
    overflow: hidden;
    border-radius: 20px;
    background:
      linear-gradient(80deg, #adffd3 15.58%, #dcdfff 84.42%),
      linear-gradient(0deg, #ffdcea 0%, #ffdcea 100%),
      linear-gradient(114deg, #baffbb 15.51%, #fff1bf 84.49%);

    > .wrapper {
      @extend %flex-column;

      padding: 40px;
      background-image: v-bind(bannerImageUrl);
      background-position: bottom right;
      background-repeat: no-repeat;
      background-position-y: -10%;

      @include vp-1439 {
        padding: 28px 40px;
        background-size: auto 100%;
        background-position: bottom -40px right -125px;
      }

      @include vp-767 {
        height: 484px;
        padding: 22px 20px;
        background-size: 100% auto;
        background-position: center bottom;
      }
    }

    > .wrapper > .header {
      max-width: 48%;
      margin-bottom: 20px;

      @include vp-1439 {
        max-width: 63%;
        margin-bottom: 30px;
      }

      @include vp-767 {
        max-width: 100%;
      }
    }

    > .wrapper > .header > .top {
      margin-bottom: 20px;
      font-size: 28px;
      font-weight: 500;
      line-height: 36px;
      color: $color-potato-90;

      @include vp-767 {
        margin-bottom: 12px;
        font-size: 20px;
        line-height: 28px;
      }
    }

    > .wrapper > .header > .footer {
      font-size: 16px;
      line-height: 24px;
      color: $color-potato-90;

      @include vp-1439 {
        font-size: 14px;
        line-height: 22px;
      }
    }

    > .wrapper .button-link {
      color: $color-potato-90;

      @include vp-767 {
        width: 100%;
        height: 48px;
        margin-top: auto;
      }
    }
  }
</style>
